import { render, staticRenderFns } from "./index.vue?vue&type=template&id=686e58df"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('686e58df')) {
      api.createRecord('686e58df', component.options)
    } else {
      api.reload('686e58df', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=686e58df", function () {
      api.rerender('686e58df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/coupon-owners/index.vue"
export default component.exports